import { render, staticRenderFns } from "./ProjectReportItem.vue?vue&type=template&id=ba711eca&scoped=true&"
import script from "./ProjectReportItem.vue?vue&type=script&lang=js&"
export * from "./ProjectReportItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectReportItem.vue?vue&type=style&index=0&id=ba711eca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba711eca",
  null
  
)

export default component.exports